<div class="eva-3-container -sm landing-figma">
  <ng-container *ngIf="!loadingIfoodInfo">
    <al-welcome-enroll
      [source]="source"
      [isClube]="!!isClube"
      [isWebView]="isWebView"
      [enrolledEmail]="enrolledEmail"
      (shareBenefitCopied)="onWelcomeShareBenefitCopied()"
    ></al-welcome-enroll>
    <al-header-loyalty
      [showHeader]="showHeader"
      [isResolutionMobile]="isResolutionMobile"
      [isClientNotEnrolled]="isClientNotEnrolled"
      [isEnrolled]="!!isEnrolled"
      [loadingIfoodInfo]="loadingIfoodInfo"
      [source]="source"
    ></al-header-loyalty>
    <al-header-landing
      [isResolutionMobile]="isResolutionMobile"
      [isClientNotEnrolled]="isClientNotEnrolled"
      [isEnrolled]="!!isEnrolled"
      [isClient]="isClient"
      [source]="source"
    ></al-header-landing>
    <al-your-points
      [isEnrolled]="isEnrolled"
      [isClientNotEnrolled]="isClientNotEnrolled"
      [isLoggedIn]="!!isLoggedIn"
      [points]="points"
      [showClubeEnrolledCashback]="showClubeEnrolledCashback"
      [showNoClubeEnrolledCashback]="showNoClubeEnrolledCashback"
      [showClubeNotEnrolledNotClientCashback]="showClubeNotEnrolledNotClientCashback"
      [showNoClubeNotEnrolledNotClientCashback]="showNoClubeNotEnrolledNotClientCashback"
      [source]="source"
    ></al-your-points>
    <al-coupons
      [isEnrolled]="!!isEnrolled"
      [isLoggedIn]="!!isLoggedIn"
      [source]="source"
    ></al-coupons>
    <al-club-benefits
      [isClube]="!!isClube"
      [source]="source"
    ></al-club-benefits>
    <al-missions
      [isEnrolled]="!!isEnrolled"
      [isLoggedIn]="!!isLoggedIn"
      [isShareWithFriends]="!!isShareWithFriends"
      [isTakeExclusiveOffers]="!!isTakeExclusiveOffers"
      [isClientNotEnrolled]="!!isClientNotEnrolled"
      [source]="source"
      [externalShareToastTrigger]="welcomeShareToastTrigger"
    ></al-missions>
    <al-faq
      [isClientNotEnrolled]="isClientNotEnrolled"
      [source]="source"
    ></al-faq>
  </ng-container>
</div>
